<template>
  <div class="orderdetial">
    <headerbox></headerbox>
    <div class="main">
      <div class="container">
        <div class="orderinfro">
          <div v-if="loading" class="loading">
            <!-- 显示加载图片 -->
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div class="infrotitle">
            <p>
              订单金额：<strong>¥</strong><b>{{ orderinfro.total_price }}</b>
            </p>
            <p>
              <span>订单号：{{ orderinfro.orderId }}</span>
            </p>
          </div>
          <div class="infroroom">
            <h2>
              {{ orderinfro.hotel_name }}
            </h2>

            <div class="infrolist">
              <span>{{ orderinfro.room_name }}</span>
              <span
                >入住日期：{{ orderinfro.check_in }} &nbsp;&nbsp;
                {{ rCheckIn }}</span
              >
              <span
                >离店日期：{{ orderinfro.check_out }} &nbsp;&nbsp;
                {{ rCheckOut }}</span
              >
               <span v-if="guestNames">入住人名字：{{ guestNames }}</span>  
              <span>入住{{ dayDifference }}晚</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="container">
        <div class="paymethod">
          <div class="paytitle">
            <span class="cur">支付方式</span>
          </div>
          <div class="paylistbox">
            <ul>
              <!-- <li
                v-show="isMobile"
                :class="{ cur: selectedPay === 'wx' }"
                @click="selectpay('wx')"
              > -->
               <li
                :class="{ cur: selectedPay === 'wx' }"
                @click="selectpay('wx')"
              > 
                <img src="@/assets/images/wx.png" />
              </li>
              <li
                :class="{ cur: selectedPay === 'zhifubo' }"
                @click="selectpay('zhifubo')"
              >
                <img src="@/assets/images/zhifubao.png" />
              </li>
          
            </ul>
            <button
              @click="paysave(orderid1)"
              class="paysubmit"
              :class="{ disabled: loading }"
              :disabled="loading"
            >
              确认支付
            </button>
            <!-- <div @click="paysave(orderinfro.ordersn)" class="paysubmit">确认支付</div> -->
          
          </div>
        </div>
      </div>
    </div>
    <div class="tipsbxoas">
        *预订费用支付后我们尽快为您确认订单，最终结果以确认短信为准。
      </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import { setStorage, getStorage } from "@/common/until/until";

import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import leftcheck from "components/content/Leftcheck";
import menuTitle from "components/content/menuTitle";
import moment from "moment";
import { postHuiyi } from "network/confercence";

export default {
  name: "OrderDetail",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    leftcheck,
    menuTitle,
  },

  data() {
    return {
      orderinfro: {},
      rCheckIn: moment(new Date()).format("YYYY-MM-DD"),
      rCheckOut: moment(new Date(new Date().getTime() + 86400000)).format(
        "YYYY-MM-DD"
      ),
      loading: true,
      selectedPay: "wx", // 默认选中的支付方式
      orderid1: "",
    };
  },
  mounted() {
    this.orderdetail();
  },
  methods: {
    paysave(ordersn) {
      const params = {
        uuid: ordersn,
        paymethod: this.selectedPay,
      };
   
     
      this.$router.push({ path: "/Pay", query: params });
    },
    selectpay(pay) {
      this.selectedPay = pay; // 更新选中的支付方式
    },
    orderdetail() {
      const orderid = this.$route.query.orderid;
      this.orderid1 = this.$route.query.orderid;
      const that = this;
      const params = {
        orderId: orderid,
      };

      postHuiyi(params)
        .then((response) => {
          console.log(response);
          that.orderinfro = response.data;
          if (that.orderinfro) {
            that.loading = false;
          }
          moment.locale("zh-cn");
          // 获取日期 "2023-11-28"
          const date1 = moment(response.data.check_in);
          const date2 = moment(response.data.check_out);
      
          that.rCheckIn = date1.format("dddd");
          that.rCheckOut = date2.format("dddd");
        })
        .catch((error) => {
          // 处理错误
          // console.error("Error:", error);
          this.$message.error("提交失败");
        });
    },
  },
  computed: {
    dayDifference() {
      const checkIn = moment(this.orderinfro.check_in);
      const checkOut = moment(this.orderinfro.check_out);
      const difference = checkOut.diff(checkIn, "days");
      return difference;
    },
    guestNames() {
      var guestNamesString = localStorage.getItem("guestNames");
  
      // 将存储的guestNames字符串解析为数组
      var guestNamesArray = JSON.parse(guestNamesString);

      // 将数组的内容使用逗号分隔转换为字符串
      var guestNamesStringUpdated = guestNamesArray.join(",");

      return guestNamesStringUpdated;
    },
    isMobile() {
      // 获取窗口的宽度
      const windowWidth = window.innerWidth;
      if (windowWidth <= 768) {
        this.selectedPay = 'wx';
      }
      // 或者使用 navigator.userAgent 检查用户代理字符串
     
      // 根据窗口宽度或用户代理字符串判断是否是手机端
      return windowWidth <= 768; // 假设小于等于 768px 的宽度为手机端
    },
  },
};
</script>
<style lang="less" scoped>
.orderdetial {
  background: #f1f1f1;
  width: 100%;

  .orderinfro {
    background: #fff;
    padding: 20px 28px;
    margin-bottom: 25px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }
  .infrotitle {
    display: flex;
    justify-content: space-between;
    color: #999;
    line-height: 50px;
    height: 50px;
    border-bottom: 1px dashed #dbdbdb;
    strong {
      color: #f70;
    }
    b {
      color: #f70;
      font-size: 24px;
      font-family: Arial;

      color: #ff7700;
    }
  }
  .infroroom {
    h2 {
      line-height: 50px;
      
      font-size: 20px;
      font-weight: 400;
      color: #333333;
    }
    .infrolist {
      line-height: 32px;

      span {
        color: #888;
        margin-right: 20px;
      }
    }
  }

  .paymethod {
    background: #fff;

    margin-bottom: 25px;
    width: 100%;
    box-sizing: border-box;
  }
  .paytitle {
    border-bottom: 1px solid #dbdbdb;
    height: 41px;
    position: relative;
    span {
      width: 120px;
      display: inline-block;
      border-top: 4px solid #fff;
      text-align: center;
      line-height: 38px;
      font-size: 14px;
      color: #444;
      border-right: 1px solid #dbdbdb;
      position: relative;
      background: #fff;
      z-index: 1;
    }
    .cur {
      border-top: 4px solid #ff7700;
    }
  }
  .paylistbox {
    padding: 40px 30px;
    ul {
      margin-bottom: 50px;
      display: flex;
      justify-content: flex-start;
      li {
        margin-right: 20px;
        display: flex;
        width: 200px;
        justify-content: center;
        align-items: center;
        height: 50px;
        background: #ffffff;
        border: 1px solid #dbdbdb;
        cursor: pointer;
      }
      .cur {
        box-shadow: 0px 0px 20px 0px rgba(255, 120, 0, 0.64);
        border: 1px solid #ff7800;
      }
    }
  }
  .tipsbxoas{
    text-align: center;
    position: relative;
    color: #999;
    font-size: 12px;
    display: none;
 
  }  
  .paysubmit {
    width: 230px;
    height: 50px;
    background: #ff7800;
    text-align: center;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    span {
      display: inline-block;
      width: 20px;
      height: 20px;
      background-color: #3498db;
      border-radius: 50%;
      opacity: 0;
      animation: scale 1s ease-in-out infinite;
      animation-delay: 0s, 0.25s, 0.5s; /* 每个元素延迟不同的时间 */
      margin: 0 5px;
    }

    @keyframes scale {
      0% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.3;
        transform: scale(0.5);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
  .disabled {
    background: #ddd;
  }

  @media (min-width: 320px) and (max-width: 780px) {
    .tipsbxoas{
      display: block;
    }
    .infrotitle {
      flex-direction: column;
      height: auto;
      min-height: 50px;
      line-height: 30px;
      padding-bottom: 10px;
    }
    .infroroom .infrolist span {
      display: block;
    }
    .paylistbox {
      ul {
        li:first-child {
          display: flex;
        }
      }
    }
  }
}
</style>

 